'use client'

import { useRevealColumn } from '@/app/components/portal/PortalMotionStyles'

/**
 * A column whose direct children rise into view as they scroll in — the
 * portal's reveal, for server-rendered pages. Disabled under
 * prefers-reduced-motion (PortalMotionStyles lands everything in place).
 */
export function RevealColumn({ id, className, children }: { id: string; className?: string; children: React.ReactNode }) {
  useRevealColumn(id)
  return (
    <div id={id} className={className}>
      {children}
    </div>
  )
}
